module.exports = __webpack_public_path__ + "img/Icon 1.1130b617.png";